document.addEventListener('DOMContentLoaded', () => {

  // Activate correct swatch
  const list = document.querySelector('product-list');
  if(list){

    list.querySelectorAll('product-card').forEach(card => {

      const link = card.querySelector('.product-card__media');
      if(!link) return;

      const match = link.href.match(/variant=(\d+)/);
      if(!match) return;

      const id = match[1];

      const radio = card.querySelector(`input[data-variant-id="${id}"]`);
      if(!radio) return;

      radio.checked = true;

      const label = card.querySelector(`label[for="${radio.id}"]`);
      if(label) label.classList.add('is-active');

    });
  }

  // Force reload on filters
  if(!location.pathname.includes('/collections/')) return;

  function checkReload(){

    const currentSearch = location.search || '';
    const lastSearch = sessionStorage.getItem('lastCollectionSearch');

    if(currentSearch !== lastSearch){

      sessionStorage.setItem('lastCollectionSearch', currentSearch);

      if(lastSearch !== null){
        location.reload();
      }
    }
  }

  const pushState = history.pushState;
  history.pushState = function(){
    pushState.apply(history, arguments);
    checkReload();
  };

  const replaceState = history.replaceState;
  history.replaceState = function(){
    replaceState.apply(history, arguments);
    checkReload();
  };

  window.addEventListener('popstate', checkReload);
  checkReload();

});

// Collection Lifestyle Card
document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.lifestyle-slider').forEach(slider => {

    const slides = slider.querySelectorAll('.lifestyle-slide');
    const wrapper = slider.closest('.lifestyle-card-wrapper');
    const pauseBtn = wrapper?.querySelector('.lifestyle-slider-pause');

    if(slides.length <= 1) return;

    let current = 0;
    let paused = false;
    let timer;

    function showSlide(index){

      clearTimeout(timer);

      slides.forEach(slide => {

        slide.classList.remove('active');

        const video = slide.querySelector('video');

        if(video){
          video.pause();
          video.currentTime = 0;
        }

      });

      const activeSlide = slides[index];

      activeSlide.classList.add('active');

      const activeVideo = activeSlide?.querySelector('video');

      if(activeVideo){

        activeVideo.play().catch(() => {});

        activeVideo.onended = function(){

          if(paused){
            return;
          }

          current = (current + 1) % slides.length;

          showSlide(current);

        };

      } else {

        timer = setTimeout(() => {

          if(paused){
            return;
          }

          current = (current + 1) % slides.length;

          showSlide(current);

        }, 1000);

      }

    }

    if(pauseBtn){

      pauseBtn.addEventListener('click', () => {

        paused = !paused;

        const activeSlide = slides[current];
        const activeVideo = activeSlide?.querySelector('video');

        if(paused){

          clearTimeout(timer);

          if(activeVideo){
            activeVideo.pause();
          }

          pauseBtn.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
              <path d="M4 2l8 6-8 6V2z"/>
            </svg>
          `;

        } else {

       if(activeVideo){

          activeVideo.play().catch(() => {});

          activeVideo.onended = function(){

            if(paused){
              return;
            }

            current = (current + 1) % slides.length;

            showSlide(current);

          };

        } else {

            clearTimeout(timer);

            timer = setTimeout(() => {

              current = (current + 1) % slides.length;

              showSlide(current);

            }, 1000);

          }

          pauseBtn.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
              <rect x="3" y="2" width="3" height="12"/>
              <rect x="10" y="2" width="3" height="12"/>
            </svg>
          `;

        }

      });

    }

    if (pauseBtn) {
      pauseBtn.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
          <rect x="3" y="2" width="3" height="12"/>
          <rect x="10" y="2" width="3" height="12"/>
        </svg>
      `;
    }
    showSlide(0);

  });

});

// Matching the heights of the lifestyle cards with the existing product cards.
document.addEventListener('DOMContentLoaded', () => {

  function matchLifestyleCardHeights() {

    const productImage = document.querySelector(
      '.product-card__figure img'
    );

    if (!productImage || !productImage.offsetHeight) return;

    const height = productImage.getBoundingClientRect().height;

    document.querySelectorAll(
      '.lifestyle-slider, .lifestyle-single-media'
    ).forEach(el => {

      el.style.height = `${height}px`;

    });

  }

  window.addEventListener(
    'resize',
    matchLifestyleCardHeights
  );

  document.addEventListener('click', (event) => {

    const button = event.target.closest(
      'collection-layout-switch button'
    );

    if (!button) return;

    setTimeout(() => {

      matchLifestyleCardHeights();
      animateLifestyleCards();

    }, 300);

    setTimeout(() => {

      matchLifestyleCardHeights();
      animateLifestyleCards();

    }, 800);

  });

  function animateLifestyleCards() {

    document.querySelectorAll('.lifestyle-card-wrapper').forEach((card, index) => {

      card.classList.remove('is-visible');

      setTimeout(() => {
        card.classList.add('is-visible');
      }, index * 50);

    });

  }

  const productList = document.querySelector('[id^="product-list"]');

  if (productList) {

    const observer = new MutationObserver(() => {

      requestAnimationFrame(() => {

        matchLifestyleCardHeights();
        animateLifestyleCards();

      });

    });

    observer.observe(productList, {
      childList: true,
      subtree: true
    });

  }

  window.addEventListener('load', () => {

    matchLifestyleCardHeights();
    animateLifestyleCards();

  });
  setTimeout(() => {

    matchLifestyleCardHeights();
    animateLifestyleCards();

  }, 300);
});